/**
 * @author liyuan <yuankylee@163.com>
 * @desc app change carefully
 * @date 2021/08/03
 */
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import AppLayout from "components/AppLayout";

export function AppContent() {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src = "https://pv.sohu.com/cityjson?ie=utf-8";
  document.head.appendChild(script);

  return (
    <Provider store={store}>
      <AppLayout />
    </Provider>
  );
}

function App() {
  // const initialData = window.__INITIAL_DATA__ || {};
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
